import ensureZepto from 'amkit3-modules/utils/ensure-zepto'
import { urlencoded } from 'amkit3-modules/utils/params'
import { getLogger } from 'amkit3-modules/utils/log4js'
const logger = getLogger('utils/ajax')

export const jsonp = (url, data, cb, needCache, jsonpCallback) => {
  logger.debug('jsonp, url[', url, '], data[', data, ']')
  ensureZepto((err, $) => {
    var tId = setTimeout(() => {
      isTimeout = true
      logger.warn('jsonp, url[', url, '], data[', data, '] timeout')
      cb(new Error('请求超时，请稍后再试'))
    }, 10000)
    var isTimeout = false

    if (err) {
      logger.debug('jsonp, url[', url, '], data[', data, '] failed, err[', err, ']')
      cb(err)
    } else {
      const options = {
        url,
        data,
        dataType: 'jsonp',
        success: (ret, status, xhr) => {
          clearTimeout(tId)
          logger.debug('jsonp, url[', url, '], data[', data, '] success, ret[', ret, ']')
          if (!isTimeout) cb(null, ret)
        },
        error: (xhr, errorType, error) => {
          clearTimeout(tId)
          logger.warn('jsonp, url[', url, '], data[', data, '] failed, err[', error, ']')
          if (!isTimeout) cb(error || new Error(errorType))
        },
      }
      if (needCache) {
        options.cache = true
      }
      if (jsonpCallback) {
        // if (!window.JSONP_METHOD_REQUEST_TIME) {
        //   window.JSONP_METHOD_REQUEST_TIME = {};
        // }
        // let time = window.JSONP_METHOD_REQUEST_TIME[jsonpCallback];
        // time = time ? time : 0;
        // options.jsonpCallback = `${jsonpCallback}_${time}`;
        // window.JSONP_METHOD_REQUEST_TIME[jsonpCallback] = time + 1;
        options.jsonpCallback = jsonpCallback
      }
      $.ajax(options)
    }
  })
}

export const sendToURL = (url, data) => {
  let u = url + (url.indexOf('?') >= 0 ? '&' : '?') + urlencoded(data)
  logger.debug('sendToURL, url[', url, '], data[', data, '], u[', u, ']')
  let image = new global.Image()
  if (!(process.env.NODE_ENV === 'development')) {
    image.src = u
  }
  return image
}

export const postToURL = (url, data) => {
  logger.debug('postToURL, url[', url, '], data[', data, ']')
  if (!(process.env.NODE_ENV === 'development')) {
    ensureZepto((err, $) => {
      if (err) return

      $.ajax({
        type: 'POST',
        url: url,
        data: data,
      })
    })
  }
}

export const post = (url, data, cb) => {
  logger.debug('post, url[', url, '], data[', data, ']')

  ensureZepto((err, $) => {
    if (err) return
    $.ajax({
      type: 'POST',
      url: url,
      data: data,
      xhrFields: {
        withCredentials: true,
      },
      crossDomain: true,
      dataType: 'json',
      success: res => {
        if (res.code === 0) {
          cb && cb(null, res)
        } else {
          cb && cb(res, null)
        }
      },
      error: err => {
        console.log(err)
        cb && cb(err, {})
      },
    })
  })
}

export const postJSON = (url, data, cb) => {
  logger.debug('post, url[', url, '], data[', data, ']')

  ensureZepto((err, $) => {
    if (err) return
    $.ajax({
      type: 'POST',
      url: url,
      data: JSON.stringify(data),
      xhrFields: {
        withCredentials: true,
      },
      crossDomain: true,
      processData: false,
      contentType: 'application/json',
      dataType: 'json',
      success: res => {
        if (res.code === 0) {
          cb && cb(null, res)
        } else {
          cb && cb(res, null)
        }
      },
      error: err => {
        console.log(err)
        cb && cb(err, {})
      },
    })
  })
}

export const get = (url, data, cb) => {
  logger.debug('post, url[', url, '], data[', data, ']')

  ensureZepto((err, $) => {
    if (err) return
    $.ajax({
      type: 'GET',
      url: url,
      data: data,
      xhrFields: {
        withCredentials: true,
      },
      crossDomain: true,
      dataType: 'json',
      success: res => {
        console.log(res)
        if (res.code === 0) {
          cb && cb(null, res)
        } else {
          cb && cb(res, null)
        }
      },
      error: err => {
        console.log(err)
        cb && cb(err, null)
      },
    })
  })
}

export default {
  jsonp,
  sendToURL,
  postToURL,
  post,
  postJSON,
  get,
}
